//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentLinesBs', {
//        templateUrl: 'views/components/views/consignmentLinesBs/consignmentLinesBs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'consignmentLinesBsService', function ($stateParams, consignmentLinesBsService) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                itemsListPicked: []
//            };
            
//            async function loadPicked() {
//                vm.model.itemsListPicked = await consignmentLinesBsService.listPicked({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }
            
//            vm.$onInit = async function () {
//                loadPicked();
//            }
//        }]
//    });
//})();
